import React from "react";
import { imgSrc } from "../../../modules";
import { Image } from "antd";
import "./service.css";
const galleries = [
    ["1.jpg", "2.jpg", "3.jpg", "4.jpg"],
    ["1.jpg", "2.jpg", "3.jpg", "4.jpg", "5.jpg", "6.jpg", "7.jpg", "8.jpg"],
];

class ServiceComponent extends React.Component {
    render() {
        const { services } = this.props;
        if (!services || typeof services != "object") {
            return <div id="services"></div>;
        }
        console.log('services' ,services)
        return (
            <div id="services">
                <div className="container">
                    <h2>บริการ</h2>
                    <p>บริษัทของเราเน้นทำงานแบบทีม(Team work) เป็นการทำงานร่วมกันและส่งเสริมกัน ไปในทางบวกผลงานรวมของทีมที่ได้ออกมาแล้ว จะมากกว่าผลงานรวมของแต่ละคนมารวมกัน ในบริษัทของเราจะมีการปรับปรุงโครงการทำงานใหม่โดยเอาการทำงานแบบทีมเข้ามาใช้ ทรัพยากร อย่างคุ้มค่าและเพื่อสร้างศักยภาพ (Potential) ในการทำงานให้กับบริษัทของเราเพื่อได้คุณภาพในการขนส่งที่ดีที่สุด</p>
                    <p><b>บริการของเรา</b></p>
                    <ul className="list">
                        <li>การจัดส่งโดยตรงไปยังลูกค้าทั่วประเทศ Direct Delivery </li>
                        <li>การขนส่งกระจายและนำส่งผู้บริโภค Cross Docking Hub DC</li>
                    </ul>
                    <div className="gallery">
                        <Image.PreviewGroup>
                            {services[0].map((value, key) => {
                                return (
                                    <Image
                                        key={"service1_" + key}
                                        src={imgSrc(value.image, false, "upload/thumbnail")}
                                        preview={{
                                            src: imgSrc(value.image, false, "upload"),
                                        }}
                                    />
                                );
                            })}
                        </Image.PreviewGroup>
                    </div>
                    <h3>รูปแบบการให้บริการ</h3>
                    <ul>
                        <li>1. บริษัทฯ จัดให้มีพนักงานตรวจสอบและขึ้นสินค้าในกรณีที่ต้องขึ้นสินค้าที่บริษัทของท่าน</li>
                        <li>2. ให้บริการด้านการฝากเอกสารการจัดส่งไปพร้อมสินค้า เพื่อให้ผู้รับปลายทางรับ และบริษัทฯ จะตรวจเช็คก่อนส่งคืน เพื่อให้ท่านเก็บไว้เป็นหลักฐานยืนยันกับลูกค้า</li>
                        <li>3. บริษัทฯ บริการด้านการรับสินค้าคืนกลับให้ท่าน ในกรณีที่มีเอกสารรับคืนสินค้า</li>
                        <li>4. รถที่ใช้ในการขนส่งเป็นรถที่มีความชำนาญในเส้นทาง อีกทั้งยังปฏิบัติตนเหมือนเป็นพนักงานในบริษัทฯ ของท่านในอันที่จะสร้างสัมพันธ์อันดีกับลูกค้าและคู่ค้าของท่าน</li>
                        <li>5. พนักงานขับรถและพนักงานประจำรถสวมชุดฟอร์มพนักงาน และแต่งตัวสุภาพเรียบร้อย เพื่อสร้างภาพลักษณ์อันดีให้กับ บริษัทฯ ของท่าน</li>
                        <li>6. บริษัทฯ จัดให้รถทุกคันมีอุปกรณ์สื่อสาร เพื่อความสะดวกในการติดต่อ และติดตามใน กรณีเร่งด่วน</li>
                        <li>7. บริษัทจัดทำรายงานสรุป ประเมินผล การจัดส่งสินค้ารายเดือน เพื่อให้บริษัทฯ ของท่านตรวจสอบมาตรฐานการดำเนินงานขนส่ง</li>
                        <li>8. บริษัทฯ พร้อมที่จะปรับปรุง หรือเปลี่ยนแปลงการให้บริการ ตามเป้าหมายและนโยบายพัฒนาการด้านใหม่ ๆ ในอนาคต ของบริษัท ฯ ท่าน</li>
                        <li>9. การจ้าง เป็นแบบรายเที่ยว เหมาเป็นเดือน หรือเป็นโครงการสัญญาระยะยาว</li>
                    </ul>
                    <h3>ยานพาหนะขนส่งของบริษัท</h3>
                    <div className="gallery has-description">
                        <Image.PreviewGroup>
                            {services[1].map((value, key) => {
                                return (
                                    <div key={'s2a'+key}>
                                        <Image
                                            key={"service2_" + key}
                                            src={imgSrc(value.image, false, "upload/thumbnail")}
                                            preview={{
                                                src: imgSrc(value.image, false, "upload"),
                                            }}
                                        />
                                        <p className='g-title'><b>{value.name}</b></p>
                                        <p>{value.description}</p>
                                    </div>
                                );
                            })}
                        </Image.PreviewGroup>
                    </div>
                </div>
            </div>
        );
    }
}

export default ServiceComponent;
